import { render } from "./TransferCreatePage.vue?vue&type=template&id=e7ef810e"
import script from "./TransferCreatePage.vue?vue&type=script&lang=js"
export * from "./TransferCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__